export default "__VITE_ASSET__D14oE7qH__"